import { render, staticRenderFns } from "./selectCourse.vue?vue&type=template&id=2f3ae507&scoped=true&name=selectCourse&"
import script from "./selectCourse.vue?vue&type=script&lang=js&"
export * from "./selectCourse.vue?vue&type=script&lang=js&"
import style0 from "./selectCourse.vue?vue&type=style&index=0&id=2f3ae507&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3ae507",
  null
  
)

export default component.exports